




import { Component, Prop, Vue } from "vue-property-decorator";
import CzSegments from "../cz/CzSegments.vue";

@Component({ components: { CzSegments } })
export default class ProgramProgress extends Vue {
  @Prop({ type: Number, default: 0 }) value!: number;
  @Prop({ type: Number, default: 1 }) max!: number;
  @Prop({ type: String, default: "" }) label!: string;
}
